export const SHOW_DURATION = 5000 * 1.5; // 5000 by default
